export default __webpack_public_path__ + "static/article-should-you-buy-a-new-or-used-car-b9c8c798b32f7cf7def442f375c1ee83.jpg";